export const supportData = {
  phoneNumber: "800-890-1553",
  helpDocURL: "https://fuzecommunity.force.com/support/",
  supportDocURL: "https://fuzecommunity.force.com/support/"
}

export function useSupportInformation() {
  return supportData
}
